import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import Gallery from "./pages/Gallery";
import Marketing from "./pages/Marketing";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "sonner";
import { ThemeProvider, THEME_FONTS_URL, useTheme } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import AnimatedBackground from "./components/AnimatedBackground";
import InstallPrompt from "./components/InstallPrompt";

// Theme-aware Toaster wrapper
const ThemedToaster = () => {
  const { theme } = useTheme();
  
  return (
    <Toaster 
      theme="dark" 
      position="bottom-right"
      toastOptions={{
        style: {
          background: theme.colors.surface,
          border: `1px solid ${theme.colors.borderActive}`,
          color: theme.colors.text,
          fontFamily: theme.fonts.body,
          borderRadius: '1rem',
          boxShadow: `0 10px 40px rgba(0,0,0,0.5), 0 0 20px ${theme.colors.primary}20`
        }
      }}
    />
  );
};

function AppContent() {
  const { theme } = useTheme();
  
  // Load theme fonts
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = THEME_FONTS_URL;
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <div className="App dark" style={{ background: theme.colors.void }}>
      {/* Animated Theme Background */}
      <AnimatedBackground />
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <ThemedToaster />
      <InstallPrompt />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
